__turbopack_context__.v({
  "className": "Y9tc_q_className",
  "variable": "Y9tc_q_variable",
});
